module.exports = __webpack_public_path__ + "media/Images/ubiquity-73148a7d9b3eef4163964f92853a06e6.svg";